import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import { Toaster } from "sonner";
import "@/App.css";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Projects from "@/pages/Projects";
import ClosedProjects from "@/pages/ClosedProjects";
import ProjectDetail from "@/pages/ProjectDetail";
import Invoices from "@/pages/Invoices";
import PendingInvoices from "@/pages/PendingInvoices";
import PendingPayments from "@/pages/PendingPayments";
import PaymentsReceived from "@/pages/PaymentsReceived";
import Reports from "@/pages/Reports";
import Notifications from "@/pages/Notifications";
import Users from "@/pages/Users";
import AuditLog from "@/pages/AuditLog";
import Settings from "@/pages/Settings";
import Incentives from "@/pages/Incentives";
import PayPublic from "@/pages/PayPublic";
import PayPalReturn from "@/pages/PayPalReturn";
import Analytics from "@/pages/Analytics";
import DataImport from "@/pages/DataImport";
import InvoicePrint from "@/pages/InvoicePrint";
import BdOutstanding from "@/pages/BdOutstanding";
import Revenue from "@/pages/Revenue";
import Team from "@/pages/Team";

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/pay/:invoice_id" element={<PayPublic />} />
          <Route path="/paypal/return" element={<PayPalReturn />} />
          <Route path="/paypal/cancel" element={<PayPalReturn />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="clients" element={<Clients />} />
            <Route path="clients/:id" element={<ClientDetail />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects-closed" element={<ClosedProjects />} />
            <Route path="projects/:id" element={<ProjectDetail />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="invoices/:invoice_id/print" element={<InvoicePrint />} />
            <Route path="pending-invoices" element={<PendingInvoices />} />
            <Route path="pending-payments" element={<PendingPayments />} />
            <Route path="payments" element={<PaymentsReceived />} />
            <Route path="reports" element={<Reports />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="revenue" element={<Revenue />} />
            <Route path="bd-outstanding" element={<BdOutstanding />} />
            <Route path="import" element={<ProtectedRoute roles={["admin", "business_development", "accounts"]}><DataImport /></ProtectedRoute>} />
            <Route path="incentives" element={<Incentives />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="users" element={<ProtectedRoute roles={["admin"]}><Users /></ProtectedRoute>} />
            <Route path="audit-log" element={<ProtectedRoute roles={["admin"]}><AuditLog /></ProtectedRoute>} />
            <Route path="settings" element={<Settings />} />
            <Route path="team" element={<Team />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
